import PrimaryButton from '../shared/buttons/PrimaryButton';
import Input from '../shared/formInput/Input';
import FormGroup from '../shared/containers/FormGroup';
import { Form, Formik } from 'formik';
import { Box } from '@mui/material';
import * as Yup from "yup";
import axios from '../../utils/axios';
import {useNotifications} from 'reapop';


const ArticleCategoryForm = ({setCatUpdated, submitUrl, submitButtonChildren}) => {

    const initialValues = {
        name: ''
    }

    const validationSchema = Yup.object({
        name: Yup.string()
            .required("champ requis"),
    });

    const formStyle = {
        margin: "1em auto",
    };

    const {notify} = useNotifications();

    const onSubmit = async (values, {resetForm, setErrors, setSubmitting}) => {
        try {
            await axios.post(submitUrl, values);
            setCatUpdated(true);
            resetForm();
            notify('Groupe article créé avec succès', 'info', {dismissAfter: 5000});
        } catch (error) {
            setErrors({createError: error.message})
            // console.error(error)
        }
    };

	return (
		<>
			<Formik {...{ initialValues, onSubmit, validationSchema, enableReinitialize:true}}>
            {({errors, isValid, dirty}) => (
                <Box>
                    {errors.createError && <p>{errors.createError}</p>}
                    <Form autoComplete="off" style={formStyle}>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "name",
                                    label: "Nom du groupe",
                                }}
                            />
                        </FormGroup>
                        <PrimaryButton type="submit" disabled={!isValid || !dirty}>
                            Envoyer
                        </PrimaryButton>
                    </Form>
                </Box>
            )}
        	</Formik>
		</>
	);
};

export default ArticleCategoryForm
